exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "cpwd .cpwd-form{padding:20px 50px;max-width:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/cpwd/cpwd.scss
// module id = 473
// module chunks = 0